export default "__VITE_ASSET__axqe1ON6__"